interface UseAppTableSelectOptions {
  onChange: (value: number) => void
}

interface UseAppTableSelectReturn {
  handleChange: (event: Event) => void
}

export const useAppTableSelect = ({ onChange }: UseAppTableSelectOptions): UseAppTableSelectReturn => {
  const handleChange = (event: Event): void => {
    const target = event.target as HTMLSelectElement
    onChange(Number(target.value))
  }

  return {
    handleChange,
  }
}
